<template>
  <div class="kye-report-echarts-bar_txt003">

    <div class="kye-report-echarts-bar_txt003-head">
      <div class="kye-report-echarts-bar_txt003-head_left"
        @click="titleClick">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div class="kye-report-echarts-bar_txt003-head_right">
        <div
          class="kye-report-echarts-bar_txt003-head_cell"
          v-for="(column, columnIndex) in columns"
          :class="`kye-report-echarts-bar_txt003-head_cell` + columnIndex"
          @click.stop="columnClick('theadClick' ,column, columnIndex)"
          :key="columnIndex">
          {{ column.name }}
          <Sort
            v-if="column.sort"
            :type="column.sortType"
            @sort="sort($event, column, columnIndex)">
          </Sort>
        </div>
      </div>
    </div>

    <div class="kye-report-echarts-bar_txt003-container">
      <div class="kye-report-echarts-bar_txt003_column"
        v-for="(item, index) in data" :key="index"
        @click="dispatchEvent('rowClick', item, index)"
        :class="{
          'kye-report-echarts-bar_txt003_select': isSelect && index === value,
          [`kye-report-echarts-bar_txt003_column-${index}`] : true
        }">
        <div class="kye-report-echarts-bar_txt003_column_label"
          @click.stop="dispatchEvent('labelClick', item, index)"
          :title="item[configKeys.name]">
          <span>{{ item[configKeys.name] }}</span>
        </div>
        <div class="kye-report-echarts-bar_txt003_column_progress">
          <el-progress
            class="kye-report-echarts-bar_txt003_column_progress_custom"
            :percentage="item[configKeys.percentage]"
            color="#8E88FF"
            :showText="false" >
          </el-progress>
        </div>
        <div class="kye-report-echarts-bar_txt003_column_summary">
          <div
            class="kye-report-echarts-bar_txt003_column_summary_cell"
            v-for="(column, columnIndex) in columns"
            :title="item[column.key]"
            @click.stop="columnClick('columnClick',column, columnIndex, item)"
            :key="columnIndex">
            {{ item[column.key] }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Sort from './sort.vue'
import { merge } from 'lodash'
const defaultKeys = {
  name: 'name',
  percentage: 'percentage',
}
export default {
  components: {
    Sort
  },
  props: {
    columns: {
      type: Array,
      default: () => ([])
    },
    data: {
      type: Array,
      default: () => ([])
    },
    props: {
      type: Object,
      default: () => defaultKeys
    },
    value: Number,
    isSelect: {
      type: Boolean,
      default: true
    },
    title: String
  },
  data() {
    return {
      select: ''
    }
  },
  watch: {
    value: {
      handler(v) {
        this.select = v
      },
      immediate: true
    }
  },
  computed: {
    configKeys() {
      const configKeys = merge(defaultKeys, this.props)
      return configKeys
    }
  },
  methods: {
    dispatchEvent(type, item, index) {
      this.$emit('input', index)
      this.$emit(type, item, index)
      this.select = index
    },
    sort(sortType, column, index) {
      this.$emit('sort', sortType, column, index)
    },
    titleClick() {
      this.$emit('titleClick', this.title)
    },
    columnClick(eventName, column, index, item = {}) {
      this.$emit(eventName, column, index, item)
    }
  }
}
</script>

<style lang="less" scoped>
  @width100: 100%;
  .kye-report-echarts-bar_txt003{
    width: @width100;
    height: @width100;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    &-head{
      display: flex;
      justify-content: space-between;
      height: 44px;
      align-items: center;
      width: 100%;
      padding: 0 16px;
      padding-right: 22px;
      &_cell{
        width: 55px;
        display: flex;
        align-items: center;
        color: #999999;
      }
      &_left{
        font-size: 12px;
        color: #999999;
      }
      &_right{
        display: flex;
        gap: 0 12px;
      }
    }
    &-container{
      flex: 1;
      width: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar{
        width: 4px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb{
        border-radius: 2px;
        background-color: rgba(118, 83, 214, .4);
      }
      div:first-child{
        margin-top: 0;
      }
    }
    &_select{
      background: #E7ECFF;
      .kye-report-echarts-bar_txt003_column_label{
        color: #FF9300;
      }
      .kye-report-echarts-bar_txt003_column_progress{
        &_custom{
          /deep/ .el-progress-bar__inner{
            background-color: #7874d3 !important;
          }
        }
      }
    }
    &_column{
      display: flex;
      align-items: center;
      height: 28px;
      padding: 0 16px;
      cursor: pointer;
      &:hover{
        background: #F6F8FC;
      }
      &:hover >&_label{
        >span {
          color: #fff;
          background-color: #FF9300;
          padding: 6px;
          line-height: 22px;
          border-radius: 6px;
        }
      }
      &_label{
        color: #666666;
        width: 50px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      &_progress{
        flex:1;
        margin-right: 24px;
        &_custom{
          /deep/ .el-progress-bar__outer{
            border-radius: 0px;
            &__inner{
              border-radius: 1px;
            }
          }
          /deep/ .el-progress-bar__inner{
            border-radius: 2px;
          }
        }
      }
      &_summary{
        display: flex;
        gap: 0 12px;
        align-items: center;
        &_cell{
          width: 55px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/bar-x/txt003/index.vue